<template>
  <transition name="fade">
    <div class="coin-popup" v-if="coinChangeData.show">
      <span>{{coinChangeData.desc}}加</span>
      <span v-if="coinChangeData.deltaValue > 0">{{coinChangeData.deltaValue}}法力值</span>
      <span v-if="coinChangeData.deltaValue > 0 && coinChangeData.deltaCoin > 0">，</span>
      <span v-if="coinChangeData.deltaCoin > 0">{{coinChangeData.deltaCoin}}法豆</span>
    </div>
  </transition>
</template>
<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState('course', ['coinChangeData']),
  },
  watch: {
    '$store.state.course.coinChangeData': {
      handler: (newVal) => {
        if (newVal.show) {
          setTimeout(() => {
            newVal.show = false
          }, 4000)
        }
      },
    },
  },
}
</script>
<style lang="scss" scoped>
  .coin-popup {
    z-index: 10000;
    position: absolute;
    left: 50%;
    bottom: 80px;
    transform: translateX(-50%);
    border-radius: 22px;
    // width: 90%;
    padding: 11px;
    line-height: 1.5;
    text-align: center;
    background: $color-black;
    box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.5);
    color: $color-white;
  }
</style>
